/** Arquivos e exames de um prontuário ou anexo (item 16) — o estado do formulário. */

export interface ArquivoSelecionado {
  /** O `arquivoId` no servidor (rascunho) ou uma chave local (anexo, antes do envio). */
  chave: string;
  titulo: string;
  nomeOriginal: string;
  mimeType: string;
  tamanhoBytes: number;
  /** Só no anexo: o arquivo ainda na máquina, que sobe junto com o anexo. */
  arquivo?: File;
}

export interface ExameSelecionado {
  exameId: string;
  nome: string;
  coletadoEm: string | null;
  origem: string;
}

export interface ItensSelecionados {
  arquivos: ArquivoSelecionado[];
  exames: ExameSelecionado[];
}

export const NENHUM_ITEM: ItensSelecionados = { arquivos: [], exames: [] };

/** Todo arquivo precisa de título — o servidor recusa sem, e aqui o botão de salvar trava antes. */
export function itensValidos(itens: ItensSelecionados): boolean {
  return itens.arquivos.every((arquivo) => arquivo.titulo.trim().length > 0 && arquivo.titulo.trim().length <= 120);
}

/**
 * No rascunho cada ação vai ao servidor na hora (o prontuário já existe); no
 * anexo nada sai até o "Salvar anexo" — aí anexo e arquivos vão num envio só.
 */
export interface OperacoesNoServidor {
  enviarArquivo: (arquivo: File, titulo: string) => Promise<ArquivoSelecionado>;
  renomearArquivo: (chave: string, titulo: string) => Promise<void>;
  removerArquivo: (chave: string) => Promise<void>;
  vincularExame: (exameId: string) => Promise<void>;
  desvincularExame: (exameId: string) => Promise<void>;
}
